import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import Icon from '../components/Icon/Icon.mjs';

const IconLeft = ({
  title,
  titleId,
  filled = void 0,
  ...props
}) => /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-hidden": !title,
    role: title ? "img" : void 0,
    width: "1em",
    height: "1em",
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      filled ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "M17.99 24l17.3-17.755a2.5 2.5 0 00-3.581-3.489l-19 19.5a2.5 2.5 0 000 3.489l19 19.5a2.5 2.5 0 103.581-3.489L17.99 24z" }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "M34.574 5.547a1.5 1.5 0 10-2.149-2.094l-19 19.5a1.5 1.5 0 000 2.094l19 19.5a1.5 1.5 0 102.149-2.094L16.594 24l17.98-18.453z" }) })
    ]
  }
) });

export { IconLeft as default };
